export const extractUniqueAttributes = (data, options = {}) => {
  const {
    uniqueBy = 'name',
    groupKeyTransform = (key) => `${key.toLowerCase()}s`,
    valueKey = 'option'
  } = options;
 
  const result = {};
  data.forEach(item => {
    item?.attributes.forEach(attr => {
      const key = groupKeyTransform(attr[uniqueBy]);
      const value = attr[valueKey];
      
      if (!result[key]) {
        result[key] = new Set();
      }
      result[key].add(value);
    });
  });
 
  return Object.fromEntries(
    Object.entries(result).map(([key, valueSet]) => [key, Array.from(valueSet)])
  );
}
